module.exports = __webpack_public_path__ + "static/media/portfolio1 (28).453cf3d5.jpeg";